export default {
  data() {
    return {
      fetchedResults: [],
      response: [],
      extra_data: "",
      appliedFilters: {},
      footerProps: {
        itemsPerPageOptions: [10, 20, 30, 40, 50]
      },
      pagination: {
        sortBy: ["modified_at"],
        descending: false,
        totalItems: 0,
        page: 1,
        rowsPerPage: 10
      },
      fullParams: ""
    };
  },
  methods: {
    getParams(params) {
      const extraParams = {
        ...params,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
        ordering: this.pagination.descending
          ? this.pagination.sortBy
          : "-" + this.pagination.sortBy
      };
      this.fullParams = this.convertToURLSearchParams(extraParams);
    },
    loadDataTable(response) {
      this.response = response;
      this.fetchedResults = response.results;
      this.pagination.totalItems = response.count;
      this.extra_data = response.extra_data;
    },
    async fetchData(params) {
      console.warn(
        "DatatableMixin: fetchData has been deprecated. Please use the function in page itself."
      );
      const extraParams = {
        ...params,
        ...this.appliedFilters,
        search: this.search,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
        ordering: this.pagination.descending
          ? this.pagination.sortBy
          : "-" + this.pagination.sortBy
      };
      const URLSearchParams = this.convertToURLSearchParams(extraParams);
      this.loading = true;
      await this.$axios
        .$get(this.endpoint, {
          params: URLSearchParams
        })
        .then(response => {
          this.response = response;
          this.fetchedResults = response.results;
          this.pagination.totalItems = response.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    applyFilters(params) {
      this.appliedFilters = params;
      this.fetchData(params);
    },
    // This utility function will build the params for multiple values with the same key (eg: /?name=Jon&name=Sam&name=Mike)
    convertToURLSearchParams(params) {
      const searchParams = new URLSearchParams();
      for (const key of Object.keys(params)) {
        const param = params[key];
        if (Array.isArray(param)) {
          for (const p of param) {
            searchParams.append(key, p);
          }
        } else {
          searchParams.append(key, param);
        }
      }
      return searchParams;
    }
  },
  watch: {
    DataTableFilter(val) {
      this.getParams(val);
      this.fetchDataTable();
    },
    search() {
      // TODO: remove search () after the refactor process
      if (typeof this.fetchDataTable !== "function") {
        this.fetchData();
      }
    },
    pagination: {
      handler() {
        // TODO: remove below typeof check after refactor process
        if (typeof this.fetchDataTable !== "function") {
          this.fetchData();
        } else {
          this.getParams(this.DataTableFilter);
          this.fetchDataTable();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
